import React from 'react';

export default function DashboardSkeleton() {
  return (
    <div className="min-h-screen pb-24">
      {/* Header Skeleton - matches BaseHeader */}
      <header className="w-full">
        <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            {/* Logo skeleton - circle icon + rounded text */}
            <div className="flex items-center gap-2">
              <div className="skeleton h-8 w-8 md:h-[60px] md:w-[60px] rounded-full"></div>
              <div className="skeleton h-4 w-24 md:h-6 md:w-32 rounded-lg"></div>
            </div>

            {/* Right side - Credits + Account */}
            <div className="flex items-center gap-2 md:gap-4">
              <div className="skeleton h-10 w-24"></div>
              <div className="skeleton h-10 w-10 rounded-full"></div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content - matches ToolsGrid max-width */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Editor's Pick Section */}
        <section className="mb-12">
          {/* Section Title */}
          <div className="mb-4">
            <div className="skeleton h-8 w-48 mb-2"></div>
            <div className="skeleton h-4 w-72"></div>
          </div>

          {/* Editor's Pick Cards - 3 large cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="skeleton h-64 w-full rounded-lg"></div>
            ))}
          </div>
        </section>

        {/* Free PFP Editor Section */}
        <section className="mb-12">
          {/* Section Title */}
          <div className="mb-4">
            <div className="skeleton h-8 w-56 mb-2"></div>
            <div className="skeleton h-4 w-96"></div>
          </div>

          {/* Tool Grid - 6 smaller cards */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="flex flex-col items-center">
                <div className="skeleton h-32 w-32 rounded-full mb-2"></div>
                <div className="skeleton h-4 w-24"></div>
              </div>
            ))}
          </div>
        </section>

        {/* Style & Appearance Section */}
        <section className="mb-12">
          {/* Section Title */}
          <div className="mb-4">
            <div className="skeleton h-8 w-64 mb-2"></div>
            <div className="skeleton h-4 w-80"></div>
          </div>

          {/* Tool Grid - 8 cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
              <div key={i} className="flex flex-col">
                <div className="skeleton h-48 w-full rounded-lg mb-2"></div>
                <div className="skeleton h-4 w-3/4 mb-1"></div>
                <div className="skeleton h-3 w-1/2"></div>
              </div>
            ))}
          </div>
        </section>

        {/* Additional Section */}
        <section>
          {/* Section Title */}
          <div className="mb-4">
            <div className="skeleton h-8 w-56 mb-2"></div>
            <div className="skeleton h-4 w-72"></div>
          </div>

          {/* Tool Grid - 6 cards */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="flex flex-col items-center">
                <div className="skeleton h-32 w-32 rounded-full mb-2"></div>
                <div className="skeleton h-4 w-20"></div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

